import * as types from '../constants/actionTypes';
import initialState from './initialState';
import { fromJS } from 'immutable';

export default function dsaReducer(state = initialState.dsa, action) {

  let newState = {...state};

  switch (action.type) {

    case types.FETCH_DSA:
      if (state.dsa && state.dsa.id !== action.id) {
        newState = {
          processing: false,
          dsaConfig: {}
        };
      }
      newState.loading = true;
      newState.error = null;
      return newState;

    case types.DISMISS_TRAINING_SNACKBAR:
      newState.trainingSnackBar = {
        maybeShow: false
      };
      return newState;

    case types.FETCH_DSA_SUCCESS: {
      // Check for the trainingSnackBar before it gets wiped out by the next line :\
      const trainingSnackBar = newState.trainingSnackBar;
      newState = parseDSA(action.data);
      if (!trainingSnackBar) {
        newState.trainingSnackBar = {
          maybeShow: true
        };
      } else {
        newState.trainingSnackBar = trainingSnackBar;
      }
      newState.loading = false;
      newState.error = null;
      return newState;
    }

    case types.FETCH_DSA_FAILURE:
      newState = {
        loading: false,
        data: action.data,
        error: action.error || 'Error Loading Assessment'
      };
      return newState;


    case types.TOGGLE_BUSINESS_AREA:
      // find the dsaArea and update state locally before we make the API call
      newState.dsaAreas = state.dsaAreas.map(a => {
        if (a.id === parseInt(action.dsaAreaId)) {
          a = {...a, active: action.active};
        }
        return a;
      });
      newState.processing = true;
      return newState;

    case types.TOGGLE_BUSINESS_AREA_SUCCESS: {
      newState.processing = false;
      return newState;
    }

    case types.TOGGLE_BUSINESS_AREA_FAILURE:
      newState.processing = false;
      console.warn('Error: ', action.error);
      // dsa level error message (see dsaView)
      // TODO: toast notifications... ?
      newState.error = action.error;
      return newState;

    case types.UPDATE_DSA_AREA_NOTE:
      return newState;

    case types.UPDATE_DSA_AREA_NOTE_SUCCESS:
      newState.dsaAreas = state.dsaAreas.map(a => {
        if (a.id === parseInt(action.dsaAreaId)) {
          a = {...a, note: action.data.note};
        }
        return a;
      });
      return newState;

    case types.UPDATE_DSA_AREA_NOTE_FAILURE:
      newState.error = action.error;
      return newState;

    case types.ANSWER_DSA_GOAL:
      // Update Answer on selected dsa goal
      newState.dsaGoals = state.dsaGoals.map(a =>
        ((a.id === action.dsaGoalId) ? {...a, answer: action.answer} : a));
      newState.processing = true;
      return newState;

    case types.UPDATE_DSA_CONFIGURED_ITEM:
    case types.CHANGE_DSA_CONFIGURED_ITEM:
      // Update configured item data on init and success (in case of overlapped calls)
      newState.dsaConfiguredItems = state.dsaConfiguredItems.map(a =>
        ((a.id === action.dsaConfiguredItemId) ? {...a, ...action.attr, updatedAt: new Date()} : a));
      newState.processing = true;
      return newState;

    case types.CREATE_DSA_CUSTOM_CONFIGURED_ITEM:
      return newState;

    case types.CREATE_DSA_CUSTOM_CONFIGURED_ITEM_SUCCESS:
      newState.dsaConfiguredItems = [...newState.dsaConfiguredItems, action.data];
      return newState;

    case types.ANSWER_DSA_USE_QUESTION:
      newState.dsaUseQuestions = state.dsaUseQuestions.map(a =>
        ((a.id === action.dsaUseQuestionId) ? {...a, answer: action.answer} : a));
      newState.processing = true;
      return newState;

    case types.ANSWER_DSA_VALUE_REALIZED:
      newState.dsaValueRealized = state.dsaValueRealized.map(a =>
        ((a.id === action.dsaValueRealizedId) ? {...a, answer: action.answer} : a));
      newState.processing = true;
      return newState;

    case types.ANSWER_CORRELATION:
      newState.dsaCorrelations = state.dsaCorrelations.map(a =>
        ((a.id === action.dsaCorrelationId) ? {...a, answer: action.answer} : a));
      newState.processing = true;
      return newState;

    case types.BATCH_ANSWER_CORRELATIONS:
      newState.dsaCorrelations = state.dsaCorrelations.map(a => {
        if (action.yes && action.yes.indexOf(a.id) >= 0) {
          return {...a, answer: 1};
        } else if (action.no && action.no.indexOf(a.id) >= 0) {
          return {...a, answer: 0};
        } else if (action.clear && action.clear.indexOf(a.id) >= 0) {
          return {...a, answer: null};
        }
        return a;
      });

      newState.processing = true;
      return newState;

    case types.UPDATE_PEAK_BUFFER:
    case types.UPDATE_PEAK_BUFFER_SUCCESS:
      newState.dsa = { ...state.dsa, peak_buffer: action.peakBuffer};
      newState.processing = action.type === types.UPDATE_PEAK_BUFFER;
      return newState;

    case types.ANSWER_DSA_GOAL_SUCCESS:
    case types.UPDATE_DSA_CONFIGURED_ITEM_SUCCESS:
    case types.ANSWER_DSA_USE_QUESTION_SUCCESS:
      newState.processing = false;
      return newState;

    case types.ANSWER_DSA_GOAL_FAILURE:
    case types.UPDATE_DSA_CONFIGURED_ITEM_FAILURE:
    case types.ANSWER_DSA_USE_QUESTION_FAILURE:
    case types.UPDATE_PEAK_BUFFER_FAILURE:
      newState.processing = false;
      newState.error = action.error;
      return newState;


    case types.CREATE_DSA:
      newState.loadingNew = true;
      newState.error = null;
      return newState;

    case types.CLONE_DSA:
      newState.cloning = true;
      return newState;

    case types.CLONE_DSA_SUCCESS:
      newState.cloning = false;
      return newState;

    case types.CONVERT_DSA:
      newState.converting = true;
      return newState;

    case types.CONVERT_DSA_SUCCESS:
      newState.converting = false;
      return newState;

    case types.CONVERT_CUSTOMER_DSA:
      newState.convertingCustomer = true;
      return newState;

    case types.CONVERT_CUSTOMER_DSA_SUCCESS:
      newState.convertingCustomer = false;
      newState.dsa = action.data.dsa;
      return newState;

    case types.CREATE_DSA_SUCCESS:
      newState = parseDSA(action.data);
      newState.loadingNew = false;
      newState.error = null;
      return newState;

    case types.CREATE_DSA_FAILURE:
      newState = {
        loadingNew: false,
        error: action.error || 'Error Loading Assessment'
      };
      return newState;

    case types.CREATE_ENGAGEMENT_ITEM_SUCCESS:
      return handleCreateEngagementItemSuccess(state, action);
    case types.DELETE_ENGAGEMENT_ITEM_SUCCESS:
      return handleDeleteEngagementItemSuccess(state, action);
    case types.UPDATE_ENGAGEMENT_ITEM_SUCCESS:
      return handleUpdateEngagementItemSuccess(state, action);

    case types.TOGGLE_SECURITY_CORRELATIONS_SUCCESS:
      newState.dsaExtensions = state.dsaExtensions.map(ext => {
        let item = Object.assign({}, ext);
        item.active = ext.id === action.data.id ? action.data.active : item.active;
        return item;
      });
      return newState;

    case types.UPDATE_DSA:
      return handleUpdateDSARequest(state, action);
    case types.UPDATE_DSA_SUCCESS:
      return handleUpdateDSASuccess(state, action);
    case types.UPDATE_DSA_FAILURE:
      return handleUpdateDSAFailure(state, action);

    default:
      return newState;
  }
}

function parseDSA(o) {
  const obj = {...o};
  //console.log(' Got Assessment: ', o);
  return obj;
}

function handleCreateEngagementItemSuccess(state, action) {
  const newState = fromJS(state);
  const engagementItems = newState.get('engagementItems');
  const categoryItems = engagementItems.get(action.data.category);

  return newState
    .set('engagementItems',
      engagementItems.set(
        action.data.category,
        categoryItems.push(action.data)))
    .toJS();
}

function handleDeleteEngagementItemSuccess(state, action) {
  const newState = fromJS(state);
  const engagementItems = newState.get('engagementItems');
  const categoryItems = engagementItems.get(action.data.category);

  return newState
    .set('engagementItems',
      engagementItems.set(
        action.data.category,
        categoryItems.filter(item => item.get('id') !== action.data.id)))
    .toJS();
}

function handleUpdateEngagementItemSuccess(state, action) {
  const newState = fromJS(state);
  const engagementItems = newState.get('engagementItems');
  const categoryItems = engagementItems.get(action.data.category);

  return newState
    .set('engagementItems',
      engagementItems.set(
        action.data.category,
        categoryItems.map(item => {
          if (item.get('id') === action.data.id){
            return action.data;
          } else {
            return item;
          }
})))
    .toJS();
}

function handleUpdateDSARequest(state, action) {
  if (!state.dsa) {
    return state;
  }

  const newState = fromJS(state);
  const newDSAState = newState.get('dsa').merge(action.updates);

  return newState
    .set('previousDSAState', state.dsa)
    .set('dsa', newDSAState)
    .toJS();
}

function handleUpdateDSASuccess(state) {
  const newState = fromJS(state);
  return newState
    .set('previousDSAState', null)
    .toJS();
}

function handleUpdateDSAFailure(state) {
  const newState = fromJS(state);
  return newState
    .set('dsa', state.previousDSAState)
    .toJS();
}



// WEBPACK FOOTER //
// ./src/reducers/dsaReducer.js